document.addEventListener('DOMContentLoaded', function () {
  const twitterBtns = Array.from(document.getElementsByClassName('twitter-tweet-btn'))

  twitterBtns.forEach(btn => {
    btn.addEventListener('click', (el) => {
      window.open(el.currentTarget.dataset.url, '', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no,width=600,height=600')
    })
  })
})